const toNumber = (value) => Number(value ?? 0) || 0;

const getBinKey = (row) => {
  if (row?.binId != null) return `id:${row.binId}`;
  const code = String(row?.binCode ?? '').trim();
  return code ? `code:${code}` : 'none';
};

const getBatchKey = (row) => {
  if (row?.batchSnId != null) return `id:${row.batchSnId}`;
  if (row?.batchId != null) return `id:${row.batchId}`;
  const batchSn = String(row?.batchSn ?? '').trim();
  return batchSn ? `code:${batchSn}` : 'none';
};

const isSameRecordKey = (line, selectedItem) => {
  const sameItemCode = String(line?.itemCode ?? '') === String(selectedItem?.itemCode ?? '');
  const sameBin = getBinKey(line) === getBinKey(selectedItem);
  const sameBatch = getBatchKey(line) === getBatchKey(selectedItem);

  return sameItemCode && sameBin && sameBatch;
};

export const calculateWmsStockValidation = ({ identifiedItem, lines, identifiedQty }) => {
  const identifiedStockQty = toNumber(identifiedItem?.effectiveQty ?? identifiedItem?.quantity);

  if (!identifiedItem) {
    return {
      identifiedStockQty,
      alreadyRecordedQty: 0,
      nextTotalQty: toNumber(identifiedQty),
      isOverStockLimit: false,
    };
  }

  const alreadyRecordedQty = (lines ?? [])
    .filter((line) => isSameRecordKey(line, identifiedItem))
    .reduce((sum, line) => sum + toNumber(line?.quantity ?? line?.qty), 0);

  const nextTotalQty = alreadyRecordedQty + toNumber(identifiedQty);

  return {
    identifiedStockQty,
    alreadyRecordedQty,
    nextTotalQty,
    isOverStockLimit: nextTotalQty > identifiedStockQty,
  };
};
